import { SkeletonLoaderArea, typographyV2 } from '@toggle/design-system';
import styled from 'styled-components';

export const SectionGroupsWrapper = styled.div`
  margin-top: 60px;
  display: flex;
  flex-direction: column;
  gap: 56px;
`;

export const SectionGroupTitle = styled.div`
  ${typographyV2.titleMd};
  color: var(--text-default);
`;

export const GroupWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const CitationsSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CitationsTitle = styled.div`
  ${typographyV2.titleMd}
`;

export const styledLoaderAreas: SkeletonLoaderArea[] = [
  {
    styles: {
      width: '100%',
      height: '700px',
      borderRadius: '8px',
    },
  },
];
